import { MatDatepickerModule } from '@angular/material';
import { SharedModule } from './../../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InvestmentsPeriodComponent } from './investments-period.component';
import { InvestmentsExtractModule } from '../investments-extract/investments-extract.module';
import { PeriodFilterComponent } from './period-filter/period-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PeriodCardsComponent } from './period-cards/period-cards.component';
import { RouterModule } from '@angular/router';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		InvestmentsExtractModule,
		FormsModule,
		MatDatepickerModule,
		ReactiveFormsModule,
		RouterModule
	],
	exports: [
		InvestmentsPeriodComponent
	],
	declarations: [
		InvestmentsPeriodComponent,
		PeriodFilterComponent,
		PeriodCardsComponent
	]
})
export class InvestmentsPeriodModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/investments/investments-period/investments-period.module.ts